export const clearStorage = () => ({
  type: "CLEAR_STORAGE",
});
